import styled from 'styled-components';

export const EmojiPickerWrapper = styled.span`
  position: relative;
  display: inline-block;
`;

export const EmojiPanel = styled.div`
  position: absolute;
  top: calc(100% + ${({theme}) => theme.getSize(1)});
  left: 0;
  width: ${({theme}) => theme.getSize(56)};
  padding: ${({theme}) => theme.getSize(2)};
  border: 1px solid ${({theme}) => theme.colors.palettes.neutral[50][100]};
  border-radius: ${({theme}) => theme.getSize(1)};
  background-color: ${({theme}) => theme.colors.palettes.white[10][100]};
  box-shadow: ${({theme}) => theme.shadows.active};
  z-index: 10;
`;

export const EmojiCategoryTabs = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${({theme}) => theme.getSize(1)};
  padding-bottom: ${({theme}) => theme.getSize(2)};
`;

export type EmojiCategoryButtonProps = {
  $isActive: boolean;
};

// Rendered as <div> rather than <button> so Quill's `.ql-snow .ql-toolbar button` rule
// (which forces width/height/float on every <button> inside the toolbar) doesn't reach
// these descendants of the toolbar wrapper.
export const EmojiCategoryButton = styled.div<EmojiCategoryButtonProps>`
  cursor: pointer;
  border: 1px solid;
  border-color: ${({theme, $isActive}) =>
    $isActive ? theme.colors.general.accent : theme.colors.palettes.neutral[50][100]};
  border-radius: ${({theme}) => theme.getSize(1)};
  background-color: ${({theme, $isActive}) =>
    $isActive ? theme.colors.palettes.blue[20][100] : theme.colors.palettes.white[10][100]};
  padding: ${({theme}) => `${theme.getSize(1)} ${theme.getSize(2)}`};
  font-size: ${({theme}) => theme.fontSizes.text.xSmall};
  user-select: none;
`;

export const EmojiGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: ${({theme}) => theme.getSize(1)};
`;

export const EmojiButton = styled.div`
  cursor: pointer;
  text-align: center;
  border: 1px solid ${({theme}) => theme.colors.palettes.neutral[40][100]};
  border-radius: ${({theme}) => theme.getSize(1)};
  background-color: ${({theme}) => theme.colors.palettes.white[10][100]};
  padding: ${({theme}) => theme.getSize(1)};
  font-size: ${({theme}) => theme.fontSizes.text.base};
  user-select: none;
`;
